import {
  getUserFacingApiErrorMessage,
} from "../services/api";
import {
  getCustomSecretRequestDetails,
  submitCustomSecrets,
} from "../services/customIntegrationApi";
import {
  SecretEntryPage
} from "./pairing/SecretEntryPage";

// Only follow http(s) links — a field's help URL may originate from the
// integration builder agent's research, so guard against javascript:/data:.
function safeHttpUrl(url: string | null | undefined): string | null {
  return url && /^https?:\/\//i.test(url) ? url : null;
}

export function EnterSecretPage() {
  return (
    <SecretEntryPage
      loadDetails={async (token) => {
        const res = await getCustomSecretRequestDetails(token);
        return {
          title: `Connect ${res.spec_display_name}`,
          subtitle: res.api_host
            ? `Catch sends these only to ${res.api_host}.`
            : null,
          fields: res.field_names.map((field) => {
            const help = res.credential_field_help?.[field];
            return {
              key: field,
              label: field.replace(/_/g, " "),
              capitalizeLabel: true,
              helpText: help?.text ?? null,
              helpUrl: safeHttpUrl(help?.url),
            };
          }),
        };
      }}
      submit={(token, values) => submitCustomSecrets(token, values)}
      mapLoadError={(err) =>
        getUserFacingApiErrorMessage(err, "Failed to load secret request")
      }
      mapSaveError={(err) =>
        getUserFacingApiErrorMessage(err, "Failed to save credentials")
      }
      description="Enter the credentials below. They're encrypted at rest and never shown to the assistant — it only accesses them by reference when making calls on your behalf."
      submitLabel="Save credentials"
      doneBody="Your credentials are saved. You can close this tab and continue the conversation with the assistant."
    />
  );
}
